export const translations = {
    'factory': 'Fabrika', 
    'add-product': 'Ürün Ekle',
    'products': 'Ürünler',
    'work-order': 'İş Emri Takip Formu',
    'view-work-order': 'İş Emri Takip Formu Görüntüleme',
    'enamel-painting-work-order': 'Emaye Boyama İş Emri Takip Formu',
    'view-enamel-painting-work-order': 'Emaye Boyama İş Emri Takip Formu Görüntüleme',
    'form-tracking': 'Form Takip Sayfası',
    'edit-product': 'Ürün Düzenle',
}